import { observer } from 'mobx-react';
import ApplyViewModel from './ApplyViewModel';
import useAsyncEffect from 'use-async-effect';
import { Button, InputOptionBox, InputErrors, InputCalendar, Input, InputType } from '../../../../core/components/Index';
import { Steps } from './ApplyModels';
import { useParams } from 'react-router-dom';
import { Appl } from '../../../../core/Appl';

const PersonalStatus = observer(() => {

  const vm = Appl.Services.get<ApplyViewModel>('ApplyViewModel');
  let { memberId } = useParams();
  useAsyncEffect(async () => {
    await vm.loadStepAsync(Steps.PersonalStatus, memberId!);
  }, []);

  return (
    <div className="space-y-6 max-w-4xl">
      <div>
        <h1 className="text-32px tracking--1percent text-neutral-800 font-semibold mb-4">Your Information</h1>
        <p className="text-black text-15px tracking--1percent leading-26px">
          Please confirm your current personal status, as this information is important for determining certain benefits and options related to your retirement.
        </p>
      </div>

      <p className="text-gray-700 font-semibold text-22px">Personal Status</p>
      <p className="text-black text-15px font-bold">Please select your current status below.</p>
      <div className="space-y-4">
        {vm.model.personalStatusListItems?.map((status, index) => (
          <>
            <div key={`lovPersonalStatus-${index}`} className="flex items-center">
              <InputOptionBox
                inputId={`lovPersonalStatusId-${status.key}`}
                label={status.value}
                value={status.key}
                checked={vm.model.personalInformation.lovPersonalStatusId?.toString() === status.key.toString()}
                // onChange={(e: any) => vm.onInputChange(e, 'lovPersonalStatusId', vm.model.personalInformation)}
                onChange={(e: any) => vm.onPersonalStatusOptionChangeAsync(e)}
                className='flex items-center'
              />
              {
                status.key == "2" && vm.model.personalInformation.lovPersonalStatusId === 2 &&

                <div className='flex ml-6 items-center -mt-0.5' >
                  <label className='text-black text-15px mr-2'>Date of Marriage:</label>
                  <div className='flex flex-col -mt-3 -my-2' >
                    <InputCalendar
                      id="marriageDate"
                      value={vm.model.personalInformation?.marriageDate!}
                      onChange={(e: any) => {
                        vm.onInputChange(e, 'marriageDate', vm.model.personalInformation);
                      }}
                      onBlur={async () => await vm.onMarriageDateChangeAsync()}
                      required={true}
                      maxDate={new Date()}
                    />
                  </div>

                </div>
              }
              {
                status.key == "3" && vm.model.personalInformation.lovPersonalStatusId === 3 &&

                <div className='flex ml-6 items-center -mt-0.5' >
                  <label className='text-black text-15px mr-2'>Partnership Date:</label>
                  <div className='flex flex-col -mt-3 -my-2' >
                    <InputCalendar
                      id="partnershipDate"
                      value={vm.model.personalInformation?.partnershipDate!}
                      onChange={(e: any) => {
                        vm.onInputChange(e, 'partnershipDate', vm.model.personalInformation);
                      }}
                      onBlur={async () => await vm.onPartnershipDateChangeAsync()}
                      required={true}
                      maxDate={new Date()}
                    />
                  </div>

                </div>
              }
            </div>

          </>
        ))}
        <InputErrors errors={Appl.Error?.items} viewId={"lovPersonalStatusId"} />
        <div className="flex mt-6 flex-wrap gap-2 sm:flex-nowrap">
          <Button title={`${vm.navigatedFromReviewScreen ? 'Save & Return to Review' : 'Save & Continue'}`}
            rounded onClick={async () => await vm.onPersonalStatusStepChangeAsync()} />
          {vm.navigatedFromReviewScreen && <Button title="Cancel & Return to Review" severity='secondary' rounded
            onClick={async () => await vm.navigateToReviewStepAsync()}
          />}
        </div>
      </div >
    </div>
  );
});

export default PersonalStatus;
